<div [ngClass]="'flex flex-column h-auto ' + (hover ? 'no-card' : 'card')">
  <div class="w-full flex gap-2 mb-3 space-between align-items-center">
    <i aria-hidden="true" class="pi pi-hourglass text-xl"></i>
    <div
      class="flex align-items-center justify-content-between w-full gap-1"
    >
      <p-tag class="w-auto" severity="success" styleClass="w-full">
        {{ "attribute.startDate" | transloco }}: ({{
          scheduledSequenceConfig.startDate | date : "dd/MM/YYYY"
        }})
      </p-tag>
      <p-tag class="w-auto" severity="danger" styleClass="w-full">
        {{ "attribute.endDate" | transloco }}: ({{
          scheduledSequenceConfig.endDate | date : "dd/MM/YYYY"
        }})
      </p-tag>
    </div>
  </div>

  <div class="w-full flex gap-2 mb-3">
    <i aria-hidden="true" class="pi pi-calendar text-xl"></i>
    <div class="flex flex-wrap gap-1 align-items-center">
      <ng-container *ngIf="isAtLeastOneDayScheduled">
        <p-tag *ngIf="scheduledSequenceConfig.monday" severity="info">
          {{ "attribute.week.monday" | transloco }}
        </p-tag>
        <p-tag *ngIf="scheduledSequenceConfig.tuesday" severity="info">
          {{ "attribute.week.tuesday" | transloco }}
        </p-tag>
        <p-tag *ngIf="scheduledSequenceConfig.wednesday" severity="info">
          {{ "attribute.week.wednesday" | transloco }}
        </p-tag>
        <p-tag *ngIf="scheduledSequenceConfig.thursday" severity="info">
          {{ "attribute.week.thursday" | transloco }}
        </p-tag>
        <p-tag *ngIf="scheduledSequenceConfig.friday" severity="info">
          {{ "attribute.week.friday" | transloco }}
        </p-tag>
        <p-tag *ngIf="scheduledSequenceConfig.saturday" severity="info">
          {{ "attribute.week.saturday" | transloco }}
        </p-tag>
        <p-tag *ngIf="scheduledSequenceConfig.sunday" severity="info">
          {{ "attribute.week.sunday" | transloco }}
        </p-tag>
      </ng-container>
      <ng-container *ngIf="!isAtLeastOneDayScheduled">
        <p [class.font-italic]="!isAtLeastOneDayScheduled"> {{ "misc.sequence.noRepeat" | transloco }} </p>
      </ng-container>
    </div>
  </div>

  <div class="flex align-items-center justify-content-between">
    <div class="flex gap-2 align-items-center">
      <i aria-hidden="true" class="pi pi-clock text-xl"></i>
      <p-tag severity="info">
        {{ 'attribute.scheduledTime' | transloco }}: {{ scheduledTime | customDate : {customFormat: "HH:mm"} }}
      </p-tag>
    </div>
  </div>
</div>
